import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/_services/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class SupportUserGuard {
  user;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {};

  checkIfSupportUserAccess() {
    this.user = this.authenticationService.getUser();
    if (this.user) {
      if (this.user.isSupportUser) { // TODO: Update this to a backend Role Check
        return true;
      } else {
        this.router.navigateByUrl('/')
        return false;
      }
    } else {
      this.router.navigateByUrl('/')
      return false;
    }
  }

  canActivate() {
    return this.checkIfSupportUserAccess();
  }

  canActivateChild() {
    return this.checkIfSupportUserAccess();
  }

  canLoad() {
    return this.checkIfSupportUserAccess();
  }
};
